var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_33349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8074 10.2207V16.5665H5.0435V10.2207H3.19922V18.5766H5.12195H5.71355H10.9359V21.5721H12.7802V18.5766H18.1373H18.581H20.6517V10.2207H18.8074Z",
    fill: "#2E283C"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.6875,
    y: 0.800781,
    width: 7.97826,
    height: 12.9647,
    fill: "#2E283C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_33349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4524,
    height: 21.4416,
    fill: "white",
    transform: "translate(3.19922 0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrophone);
export default __webpack_public_path__ + "static/media/ic_microphone.24db18ad14abe90c123e5ab776a7ce6f.svg";
export { ForwardRef as ReactComponent };